import RegistrationTracker from './RegistrationTracker';

document.addEventListener('DOMContentLoaded', () => {
  if (!document.getElementById('learner-registration-completed')) return;

  const tracker = new RegistrationTracker();
  tracker.track(4, { subset: 'auth' });
});
